"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Summary = void 0;
var jsx_runtime_1 = require("preact/jsx-runtime");
var Summary = function (_a) {
    var config = _a.config, shipment = _a.shipment;
    return ((0, jsx_runtime_1.jsxs)("div", { class: "artajs__tracking__summary__wrapper", children: [(0, jsx_runtime_1.jsx)("div", { class: "artajs__tracking__summary__content", children: (0, jsx_runtime_1.jsx)("div", { class: "artajs__tracking__summary__title", children: shipment.shortcode }) }), (0, jsx_runtime_1.jsx)("div", { class: "artajs__tracking__summary__date", children: "".concat(config.text.bookedLabel).concat(new Date(shipment.created_at).toLocaleString()) })] }));
};
exports.Summary = Summary;
